export const parseBoundedIntegerInput = (
  raw: string,
  min: number,
  max: number,
): number | null => {
  const trimmed = raw.trim();
  if (trimmed === '') {
    return null;
  }
  if (!/^\d+$/.test(trimmed)) {
    return null;
  }
  const value = Number(trimmed);
  if (value < min || value > max) {
    return null;
  }
  return value;
};
